import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import * as dumbleData from 'DumbleData';
import produce from 'immer';
import './DiscoverForm.scss'
import BookWizardIcon from 'images/bw-logo-blue.svg';
import CloseButtonIcon from 'images/close-button.svg';
import LightningIcon from 'images/lightning-icon.svg';
import SolidButton from 'components/content/Button/SolidButton.js';
import OutlineButton from 'components/content/Button/OutlineButton.js';
import LevelPage from 'components/content/DiscoverForm/LevelPage/LevelPage.js';
import GradePage from 'components/content/DiscoverForm/GradePage/GradePage.js';
import ReadingLevelPage from 'components/content/DiscoverForm/ReadingLevelPage/ReadingLevelPage.js';
import CategoryPage from 'components/content/DiscoverForm/CategoryPage/CategoryPage.js';
import SubjectPage from 'components/content/DiscoverForm/SubjectPage/SubjectPage.js';
import GenrePage from 'components/content/DiscoverForm/GenrePage/GenrePage.js';

export class DiscoverForm extends Component {

	constructor(props){
		super(props);
		this.state = {
			step: 1,
			level: '',
			readingLevelSystem: '',
			lexileCode: '',
			readingLevelMin: '',
			readingLevelMax: '',
			readingLevelMinDisplay: '',
			readingLevelMaxDisplay: '',
			slider: {
				"showSlider" : {selected: false},
			},
			gradeLevels: {
				"prek" : {display_name: "Pre-K", selected: false},
				"kindergarten" : {display_name: "Kindergarten", selected: false},
				"grade-1" : {display_name: "Grade 1", selected: false},
				"grade-2" : {display_name: "Grade 2", selected: false},
				"grade-3" : {display_name: "Grade 3", selected: false},
				"grade-4" : {display_name: "Grade 4", selected: false},
				"grade-5" : {display_name: "Grade 5", selected: false},
				"grade-6" : {display_name: "Grade 6", selected: false},
				"grade-7" : {display_name: "Grade 7", selected: false},
				"grade-8" : {display_name: "Grade 8", selected: false},
				"grade-9" : {display_name: "Grade 9", selected: false},
				"grade-10" : {display_name: "Grade 10", selected: false},
				"grade-11" : {display_name: "Grade 11", selected: false},
				"grade-12" : {display_name: "Grade 12", selected: false}
			},
			categories: {
				"fiction" : {display_name: "Fiction", selected: false},
				"non-fiction" : {display_name: "Nonfiction", selected: false}
			},
			subjects: {},
			genres: {},
			cachedSubjectFacets: '',
			cachedGenreFacets: '',
			isFilterUpdate: false
		}
	}

	componentDidMount() {
		if(this.props.history.location.state){
			this.setState(this.props.history.location.state);
		}
		dumbleData.setPageType('Discover');
		dumbleData.setTitle('BookWizard:Discover');
	}

	nextStep = () => {
		/* use nav buttons to toggle btw slider and slider
		selector in reading level system page */
		if(this.state.step === 2 
			&& this.state.readingLevelSystem !== '' 
			&& !this.state.slider.showSlider.selected
			&& this.state.level === 'reading') {
			this.handleChangeCheckbox('slider','showSlider');
		} else if (this.state.step === 5) {
			this.renderResultsPage();
		} else {
			this.setState({ step: (this.state.step + 1) });
		}
	};

	prevStep = () => {
		/* use nav buttons to toggle btw slider and slider
		selector in reading level system page */
		if(this.state.step === 2 
			&& this.state.readingLevelSystem !== '' 
			&& this.state.slider.showSlider.selected
			&& this.state.level === 'reading') {
			this.handleChangeCheckbox('slider','showSlider');
		} else {
			if(this.state.step === 1) {
				this.props.history.push({
					pathname: '/',
				});
			}
			this.setState({ step: (this.state.step - 1) });
		}
	};

	renderResultsPage = () => {
		let selectedReadingLevel = this.state.readingLevelSystem;
		let selectedReadingLevelRange = this.state.readingLevelMin + '-' + this.state.readingLevelMax;
		let selectedGrades = this.getSelectedFacets('gradeLevels');
		let selectedCategories = this.getSelectedFacets('categories');
		let selectedSubjects = this.getSelectedFacets('subjects');
		let selectedGenres = this.getSelectedFacets('genres');
		this.props.history.push({
			pathname: '/results',
			state: { 
				browseQuery: this.state,
				browseFacets: [selectedReadingLevel, selectedReadingLevelRange, selectedGrades, selectedCategories, selectedSubjects, selectedGenres]
			}
		});
	}

	/* handle when user clicks close X before updating filters completely */
	renderLastResultsPage = () => {
		this.setState(this.props.history.location.state, () => { 
			this.renderResultsPage();
		});
	}

	//Iterate facets and return only those with a selected property set to true
	getSelectedFacets = (facetName) => {
		return Object.entries(this.state[facetName])
				.filter(([key, value]) => value.selected)
				.map(facet => facet[0]);
	}

	handleChangeCheckbox = (key, value) => {
		this.setState(prevState => {
			return produce(prevState, draft => {
				draft[key][value].selected = !prevState[key][value].selected;
			})
		});
	}

	handleChangeRadio = (key, value) => {
		if(this.state[key] === value) {
			this.setState({ [key] : '' });
		} else {
			this.setState({ [key] : value });
		}
	}

	handleChangeValue = (key, value) => {
		this.setState({ [key] : value });
	}

	render() {
		const { step } = this.state;
		const { level, readingLevelSystem, slider, gradeLevels, categories, subjects, genres, lexileCode, readingLevelMin, readingLevelMax, readingLevelMinDisplay, readingLevelMaxDisplay} = this.state;
		const values = { level, readingLevelSystem, slider, gradeLevels, categories, subjects, genres, lexileCode, readingLevelMin, readingLevelMax, readingLevelMinDisplay, readingLevelMaxDisplay};
		const sliderHeadings = {
			"lexileLevel": "Select a Lexile\xAE Measure or Range",
			"guidedReadingLevel": "Select a Guided Reading Level or Range",
			"draLevel": "Select a Developmental Reading Assessement (DRA) Level or Range",
			"acceleratedReaderLevel": "Select an Accelerated Reader (ACR) Level or Range",
		}
		let nextDisabled = false;
		let nextButtonText = step === 5 ? "VIEW RESULTS" : "NEXT";
		let nextButtonIcon = step === 5 ? LightningIcon : null;
		let optional = false;
		let currentPage;
		let pageHeading;

		// Switch statement to render page component based on step
		switch (step) {
			case 1:
				pageHeading = "We can help you discover books by...";
				nextDisabled = this.state.level === ''
				currentPage = 
					<LevelPage
						nextStep={this.nextStep}
						handleChange={this.handleChangeRadio}
						values={values}
					/>;
				break;
			case 2:
				if (this.state.level === 'grade') {
					pageHeading = "Select one or more Grade";
					nextDisabled = !Object.values(this.state.gradeLevels).some(grade => grade.selected);
					currentPage = 
						<GradePage
							nextStep={this.nextStep}
							handleChange={this.handleChangeCheckbox}
							values={values}
						/>;
				} else if (this.state.level === 'reading') {
					pageHeading = this.state.slider.showSlider.selected ? sliderHeadings[this.state.readingLevelSystem] : "Select a Reading Level System";
					optional = this.state.slider.showSlider.selected;
					nextDisabled = this.state.readingLevelSystem === ''
					currentPage = 
						<ReadingLevelPage
							nextStep={this.nextStep}
							handleChange={this.handleChangeRadio}
							handleChangeCheckbox={this.handleChangeCheckbox}
							handleChangeValue={this.handleChangeValue}
							values={values}
						/>;
				}
				break;
			case 3:
				pageHeading = "Select the Categories you're interested in";
				optional = true;
				currentPage = 
					<CategoryPage
						nextStep={this.nextStep}
						handleChange={this.handleChangeCheckbox}
						values={values}
					/>;
				break;
			case 4:
				pageHeading = "Select all the Subjects you're interested in";
				optional = true;
				currentPage = 
					<SubjectPage
						nextStep={this.nextStep}
						handleChange={this.handleChangeCheckbox}
						handleChangeValue={this.handleChangeValue}
						values={values}
						getSelectedFacets={this.getSelectedFacets}
						setDynamicFacets={this.handleChangeValue}
						cachedFacets={this.state.cachedSubjectFacets}
					/>;
				break;
			case 5:
				pageHeading = "Select all the Genres you're interested in"
				optional = true;
				currentPage = 
					<GenrePage
						nextStep={this.nextStep}
						handleChange={this.handleChangeCheckbox}
						handleChangeValue={this.handleChangeValue}
						values={values}
						getSelectedFacets={this.getSelectedFacets}
						setDynamicFacets={this.handleChangeValue}
						cachedFacets={this.state.cachedGenreFacets}
					/>
				break;
			default:
				break;
		}

		return (
			<div className="discoverForm">
				<div className="discoverForm__content">
					<div className="discoverForm__content-header">
						{this.state.isFilterUpdate
							? 	<div onClick={this.renderLastResultsPage}>
									<img src={BookWizardIcon} className="discoverForm__content-header--logo" alt="Book Wizard Logo" tabIndex="0"></img>
									<img src={CloseButtonIcon} className="discoverForm__content-header--close" alt="Close Button" tabIndex="0"></img>
								</div>
							: 	<Link to="/">
									<img src={BookWizardIcon} className="discoverForm__content-header--logo" alt="Book Wizard Logo" tabIndex="0"></img>
									<img src={CloseButtonIcon} className="discoverForm__content-header--close" alt="Close Button" tabIndex="0"></img>
								</Link>
						}
					</div>
					<div className="grid-layout">
						<p className="discoverForm__step-heading">{step} OF 5</p>
						<p className="discoverForm__page-heading">{pageHeading}</p>
						<p className="discoverForm__optional-heading">{optional ? "Optional" : null}</p>
						{currentPage}
					</div>
				</div>
				<div className="discoverForm__footer">
					<div className="discoverForm__footer_buttons__wrapper grid-layout">
						<div className="discoverForm__footer_buttons">
							<OutlineButton 
								color="blue" 
								text="BACK" 
								alt="Back Button" 
								className="discoverForm__back-button" 
								handleClick={this.prevStep}/>
							<SolidButton 
								color="blue" 
								text={nextButtonText}
								icon={nextButtonIcon}
								iconLeft
								alt="Next Button" 
								disabled={nextDisabled} 
								className={`discoverForm__next-button ${nextButtonIcon ? "icon" : ""}`}
								handleClick={this.nextStep}/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default withRouter(DiscoverForm)